import React from 'react';
import PropTypes from 'prop-types';

const HelpText = ({ name, text }) => {
  return (
    <p className="uni-form__help-message" id={name + 'Help'}>
      {text}
    </p>
  );
};

HelpText.propTypes = {
  name: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default HelpText;



// WEBPACK FOOTER //
// ./src/forms/__partials/help-text.jsx